import Unit from '@leverege/unit';
import { Plugins } from '@leverege/plugin';
import Util from './Util.js';
import AttributeExportFieldModel from './AttributeExportFieldModel.js';
import AttributeExportFieldEditor from "./AttributeExportFieldEditor.js";
import UnitAttributeExportFieldModel from './UnitAttributeExportFieldModel.js';
import UnitAttributeExportFieldEditor from "./UnitAttributeExportFieldEditor.js";
function createUnitSpecificObjects() {
  const types = Unit.getUnitTypes();
  types.forEach(type => {
    // const key = `${type[0].toUpperCase()}${type.substring( 1 )}`
    const detailType = Util.getExportFieldTypeForType(type);
    const model = UnitAttributeExportFieldModel.createFor(type);
    const editor = UnitAttributeExportFieldEditor;
    // const renderer = UnitAttributeColumnRenderer

    // exports[`${key}AttributeExportFieldModel`] = model
    // exports[`${key}AttributeColumnRenderer`] = UnitAttributeColumnRenderer

    // Not super happy with plugin registration here, but it can 
    // be overwritten if necessary
    Plugins.add('Model', {
      type: detailType,
      model
    });
    Plugins.add('ModelEditor', {
      type: detailType,
      editor
    });
    // Plugins.add( 'ColumnRenderer', { type : detailType, renderer } )
  });
}
export default {
  install: opts => {
    createUnitSpecificObjects();
    Plugins.add('Model', {
      type: AttributeExportFieldModel.TYPE,
      model: AttributeExportFieldModel
    });
    Plugins.add('ModelEditor', {
      type: AttributeExportFieldModel.TYPE,
      editor: AttributeExportFieldEditor
    });
    const strType = Util.getExportFieldTypeForType('string');
    Plugins.add('Model', {
      type: strType,
      model: AttributeExportFieldModel.createFor(strType)
    });
    Plugins.add('ModelEditor', {
      type: strType,
      editor: AttributeExportFieldEditor
    });
    Plugins.add('Model', {
      type: `${strType}*`,
      model: AttributeExportFieldModel.createFor(strType)
    });
    Plugins.add('ModelEditor', {
      type: `${strType}*`,
      editor: AttributeExportFieldEditor
    });
  }
};